import { render, staticRenderFns } from "./ResultadoComprador.vue?vue&type=template&id=84c10de8&scoped=true"
import script from "./ResultadoComprador.vue?vue&type=script&lang=js"
export * from "./ResultadoComprador.vue?vue&type=script&lang=js"
import style0 from "./ResultadoComprador.vue?vue&type=style&index=0&id=84c10de8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c10de8",
  null
  
)

export default component.exports